<template>
  <div class="calico-pagination-page">
    <CalicoPagination
      :pages="30"
      label="1-20 of 40"
    />
  </div>
</template>
  
  <script>
  import CalicoPagination from '@/components/calico/pagination/index.vue';
  
  export default {
    name: "CalicoPaginationPage",
    components: { CalicoPagination },
    data() {
      return { page: 3 };
    }
  };
  </script>
  <style lang="scss">
  .calico-pagination-page {
    padding-top: 100px;
  }

  </style>
  